// Counter Up on Numbers when visible
$(document).ready(function(){
    $('.ops-js-counterUp').counterUp({
        delay: 10,
        time: 500,
        offset: 90
    });
})
